export const oidcAuthority = `${import.meta.env.VITE_FWS_URL}/authentication/v1/sso`;
export const oidcClientId = import.meta.env.VITE_AUTH_WIDGET_CLIENT_ID;
